import { ProductType } from "./productType";

type IconProps = { className?: string };

const svgProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

const BedIcon = ({ className }: IconProps) => (
  <svg className={className} {...svgProps}>
    <path d="M3 8v10" />
    <path d="M3 17h18v-4a3 3 0 0 0-3-3H8" />
    <path d="M21 18v-1" />
    <path d="M7 12v-2a1 1 0 0 1 1-1" />
    <circle cx="7" cy="12" r="0.5" />
  </svg>
);

const SofaIcon = ({ className }: IconProps) => (
  <svg className={className} {...svgProps}>
    <path d="M4 11V9a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2" />
    <path d="M4 11a2 2 0 0 0-2 2v3h20v-3a2 2 0 0 0-2-2 2 2 0 0 0-2 2v1H6v-1a2 2 0 0 0-2-2Z" />
    <path d="M5 19v-3" />
    <path d="M19 19v-3" />
  </svg>
);

const SectionalIcon = ({ className }: IconProps) => (
  <svg className={className} {...svgProps}>
    <path d="M4 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6h6a2 2 0 0 1 2 2v6h-4v-2H6v2H2V7a2 2 0 0 1 2-2Z" />
    <path d="M4 11h8" />
  </svg>
);

const ChairIcon = ({ className }: IconProps) => (
  <svg className={className} {...svgProps}>
    <path d="M6 11V7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4" />
    <path d="M6 11a2 2 0 0 0-2 2v2h16v-2a2 2 0 0 0-2-2Z" />
    <path d="M5 15v4" />
    <path d="M19 15v4" />
  </svg>
);

const OttomanIcon = ({ className }: IconProps) => (
  <svg className={className} {...svgProps}>
    <rect x="3" y="9" width="18" height="7" rx="2" />
    <path d="M6 16v3" />
    <path d="M18 16v3" />
    <path d="M6 12h12" />
  </svg>
);

const PillowIcon = ({ className }: IconProps) => (
  <svg className={className} {...svgProps}>
    <path d="M5 5c-1.5 3-1.5 11 0 14 3 1.5 11 1.5 14 0 1.5-3 1.5-11 0-14C16 3.5 8 3.5 5 5Z" />
    <path d="M7 7c-.5 2.5-.5 7.5 0 10" />
  </svg>
);

const UnknownIcon = ({ className }: IconProps) => (
  <svg className={className} {...svgProps}>
    <rect x="4" y="4" width="16" height="16" rx="2" />
    <path d="M9 9a3 3 0 0 1 5 2c0 1.5-2 2-2 3" />
    <circle cx="12" cy="17" r="0.5" />
  </svg>
);

const ICONS: Record<ProductType, (props: IconProps) => JSX.Element> = {
  bed: BedIcon,
  sofa: SofaIcon,
  sectional: SectionalIcon,
  chair: ChairIcon,
  ottoman: OttomanIcon,
  pillow: PillowIcon,
  unknown: UnknownIcon,
};

/** Small line icon representing a SKU's product type, shown before the SKU in the picker. */
export const ProductTypeIcon = ({ type, className }: { type: ProductType; className?: string }) => {
  const Icon = ICONS[type] ?? UnknownIcon;
  return <Icon className={className} />;
};
